import { BaseAction } from 'redux-actions';
import { SimManagementError } from 'src/models/Errors';
import { MvnoBundle } from 'src/models/state/mvnoBundle';
import {
  LOAD_MVNO_BUNDLE_FAILURE,
  LOAD_MVNO_BUNDLE_PENDING,
  LOAD_MVNO_BUNDLE_SUCCESS,
  ENSURE_MVNO_BUNDLE,
} from './actionTypes';
import { Action } from './commonActions';

export function ensureMvnoBundle(payload: string): Action<any> {
  return {
    type: ENSURE_MVNO_BUNDLE,
    payload,
  };
}

export function loadMvnoBudlesPending(): BaseAction {
  return {
    type: LOAD_MVNO_BUNDLE_PENDING,
  };
}

export function loadMvnoBudlesFailure(error: SimManagementError): Action<SimManagementError> {
  return {
    type: LOAD_MVNO_BUNDLE_FAILURE,
    payload: error,
  };
}

export function loadMvnoBundlesSuccess(item: MvnoBundle): Action<MvnoBundle> {
  return {
    type: LOAD_MVNO_BUNDLE_SUCCESS,
    payload: item,
  };
}
